import { Card, CardContent } from '../ui/card';
import { Users, TrendingUp, Wallet, Clock } from 'lucide-react';
import { formatCurrency } from '../../utils/formatUtils';

/**
 * Admin dashboard stats grid - 4 clickable stat cards
 */
export const AdminStatsGrid = ({ 
  dashboard, 
  hasPermission, 
  onNavigate 
}) => {
  const stats = [
    {
      icon: Users,
      iconClass: 'text-primary',
      value: dashboard?.users?.total || 0,
      label: 'Total Users',
      subLabel: `+${dashboard?.users?.today || 0} today`,
      subClass: 'text-green-600',
      permission: 'users',
      link: '/admin/users',
      format: 'number'
    },
    {
      icon: TrendingUp,
      iconClass: 'text-green-600',
      value: dashboard?.revenue?.total_buy_inr || 0,
      label: 'Total Revenue',
      subLabel: `${dashboard?.revenue?.total_buy_count || 0} transactions`,
      subClass: 'text-green-600',
      permission: 'transactions',
      link: '/admin/transactions',
      format: 'currency'
    },
    {
      icon: Wallet,
      iconClass: 'text-purple-600',
      value: (dashboard?.milli?.total_balance || 0).toFixed(0),
      label: "Total Milli's",
      subLabel: `${dashboard?.milli?.gold_equivalent_grams || 0}g gold`,
      subClass: 'text-purple-600',
      permission: 'reports',
      link: '/admin/outstanding',
      format: 'number'
    },
    {
      icon: Clock,
      iconClass: 'text-orange-600',
      value: dashboard?.transactions?.pending || 0,
      label: 'Pending Txns',
      subLabel: `${dashboard?.vouchers?.active || 0} active vouchers`,
      subClass: 'text-orange-600',
      permission: 'transactions',
      link: '/admin/vouchers',
      format: 'number'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        const displayValue = stat.format === 'currency' 
          ? formatCurrency(stat.value) 
          : stat.value;
        
        return (
          <Card 
            key={index}
            className="border-gold/20 cursor-pointer hover:shadow-lg transition-shadow"
            onClick={() => hasPermission(stat.permission) && onNavigate(stat.link)}
          >
            <CardContent className="p-4 text-center">
              <Icon className={`w-8 h-8 ${stat.iconClass} mx-auto mb-2`} />
              <p className="text-2xl font-bold text-navy">{displayValue}</p>
              <p className="text-xs text-muted-foreground">{stat.label}</p>
              <p className={`text-xs ${stat.subClass} mt-1`}>{stat.subLabel}</p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default AdminStatsGrid;
